module.exports = __webpack_public_path__ + "static/media/washy_logo.2808966b.png";